export const botResponseActions = {
  calendarCheckIn: 'calendarCheckIn',
  liveChatOff: 'liveChatOff',
  liveChatOn: 'liveChatOn',
  requestSupport: 'requestSupport',
  updateParticipantField: 'updateParticipantField',
}
